class CalendarChristmasCartSync {
  constructor({ christmasVariants, onHasChristmas, onNoChristmas }) {
    this.christmasVariants = christmasVariants || {};
    this.onHasChristmas = onHasChristmas;
    this.onNoChristmas = onNoChristmas;
  }

  cartHasChristmasItem(cart) {
    return cart.items.some(
      (item) =>
        item.variant_id &&
        Object.values(this.christmasVariants).some(
          (section) => section[String(item.variant_id)] === true,
        ),
    );
  }

  async check() {
    const res = await fetch("/cart.js");
    const cart = await res.json();

    if (this.cartHasChristmasItem(cart)) {
      await this.setAttribute(true);
      this.onHasChristmas?.();
    } else {
      await this.setAttribute(false);
      this.onNoChristmas?.();
    }
  }

  async setAttribute(value) {
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: { has_christmas_item: value ? "true" : "" },
      }),
    });
  }

  async stillHasChristmasItem() {
    const res = await fetch("/cart.js");
    const cart = await res.json();
    return this.cartHasChristmasItem(cart);
  }
}

